import './ActionTemplateCard.scss';
import classNames from 'classnames';
import React from 'react';
import { SonarText } from '@ui/text';
import { StackIcon } from '@ui/icons';
import { BankOutlined, FileOutlined, HistoryOutlined, TeamOutlined } from '@ant-design/icons';
import { Card, Flex, Tag } from 'antd';
import { DataSecurityMonitorType } from '@sonar-software/sonar-core';
export const labelMetaLookup = {
    'Data Dictionary': {
        color: 'purple',
        icon: React.createElement(BankOutlined, null)
    },
    'New User': {
        color: 'green',
        icon: React.createElement(TeamOutlined, null),
        monitorType: DataSecurityMonitorType.NewUser
    },
    'Object and Field Access': {
        color: 'cyan',
        icon: React.createElement(StackIcon, null),
        monitorType: DataSecurityMonitorType.ConfigurableFieldAccess
    },
    'Setup Audit Trail': {
        color: 'orange',
        icon: React.createElement(FileOutlined, null),
        monitorType: DataSecurityMonitorType.SetupAuditTrail
    },
    'Uptime': {
        color: 'magenta',
        icon: React.createElement(HistoryOutlined, null),
        monitorType: DataSecurityMonitorType.Uptime
    }
};
export const ActionTemplateCard = ({ description, disabled, id, label, name, onClick }) => {
    var _a;
    const { color, icon } = (_a = labelMetaLookup[label]) !== null && _a !== void 0 ? _a : {};
    return (React.createElement(Card, { className: classNames('action-template-card', { disabled: disabled }), hoverable: !disabled, onClick: () => !disabled && (onClick === null || onClick === void 0 ? void 0 : onClick(id)) },
        React.createElement(Tag, { className: 'template-icon-area', color: color, icon: icon }),
        React.createElement(Flex, { className: 'action-template-card-content', vertical: true },
            React.createElement(Tag, { className: 'action-template-label', color: color }, label),
            React.createElement("h3", null, name),
            React.createElement(SonarText, null, description))));
};
